import React, { Component } from "react";
import Slider from "react-slick";
// import AboutUsImages from "../../models/AboutUsSliderData";


const AboutUsImages = import.meta.glob('../assets/images/AboutUs/*.{jpg,jpeg,png,gif,webp}', { eager: true });

// Create an array of objects containing imageLink and altText
const allImagesData = Object.entries(AboutUsImages).map(([path, file]) => {
  const imageName = path.split('/').pop().split('.')[0]; // Extract the image name without extension
  return {
    imageLink: file.default,
    altText: `${imageName} Image`,
  };
});

function AboutUsSlider() {

  const settings = {

    autoplay: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
      {allImagesData.map(({ imageLink, altText }, index) => (
        <div key={index}>
          <img src={imageLink} alt={altText} />
        </div>
      ))}

      </Slider>

      <AboutUsImages />

    </div>
  );
}

export default AboutUsSlider;
